import { getSelectedOption } from '../../../../../utils/selectFormat';
import { useSessionFormLoaderData } from '../../create/hooks/SessionFormLoader';
import { FormCreate } from '../../create/parts/FormCreate';
import { StudentRiskEvaluationSessionResponse } from '../../create/types';
import { useSessionViewLoaderData } from '../hooks/SessionViewLoader';

export const FormUpdate = ({
  handleOnSumbit,
}: {
  handleOnSumbit: (
    values: StudentRiskEvaluationSessionResponse & { id: number },
  ) => void;
}) => {
  const data = useSessionViewLoaderData();
  const {
    periods: periodOptions,
    schools: schoolOptions,
    years: yearsOptions,
  } = useSessionFormLoaderData();

  const defaultValues = {
    id: data.id,
    school: getSelectedOption(data.schoolId, schoolOptions),
    period: getSelectedOption(data.periodId, periodOptions),
    year: getSelectedOption(data.year, yearsOptions),
    sessionName: data.name,
    sessionDate: data.date,
    initDate: data.startAt,
    endDate: data.endAt,
    description: data.description,
    participants: data.participants.map((p) => ({
      id: p.id,
      value: p.accountId,
      name: p.name,
      email: p.email,
    })),
  };

  return (
    <>
      <FormCreate
        defaultValues={defaultValues}
        disabled
        handleOnSumbit={(values) =>
          data?.id && handleOnSumbit({ ...values, id: data.id })
        }
      />
    </>
  );
};
